import React from 'react'
import QuarterlyMeeting from './QuarterlyMeeting';
export default function QuarterlyMeetingList({oym,list,dropBreadcrumb,authenticated}) {
    console.log("QM List authenticated "+authenticated);
    let objectList=list.map(meeting => oym.objectRef(meeting));
    objectList.sort(oym.compareOYMObject);
    let quarterlyMeetings=objectList.map(quarterlyMeeting => {
        console.log(quarterlyMeeting.name);
        return <QuarterlyMeeting key={quarterlyMeeting.name} quarterlyMeeting={quarterlyMeeting} oym={oym} dropBreadcrumb={dropBreadcrumb} authenticated={authenticated}  />
    });
    return (
        <div>
            {quarterlyMeetings}
        </div>
    )
}
